var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    [
      _vm._t("logo"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "headerlink-wrapper",
          class: { "has-navbar-icon": _vm.showNavbarIcons }
        },
        [
          _vm.user.is_authenticated
            ? _c(
                "router-link",
                {
                  class: [
                    {
                      "hdr-link": !_vm.isMobile(_vm.$mq),
                      "hdr-link-mobile": _vm.isMobile(_vm.$mq)
                    }
                  ],
                  attrs: {
                    to: { name: "userhome" },
                    "active-class": "active",
                    "data-testid": "header_link"
                  }
                },
                [
                  _vm.showNavbarIcons
                    ? _c("NavbarIcon", {
                        staticClass: "navbar-icon",
                        attrs: { icon: "home" }
                      })
                    : _vm._e(),
                  _vm._v("\n      Home\n    ")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMobile(_vm.$mq) || _vm.user.is_authenticated
            ? _c(
                "router-link",
                {
                  class: {
                    "hdr-link": !_vm.isMobile(_vm.$mq),
                    "hdr-link-mobile": _vm.isMobile(_vm.$mq)
                  },
                  attrs: {
                    to: { name: "explorations_menu" },
                    "active-class": "active",
                    "data-testid": "header_link"
                  }
                },
                [
                  _vm.showNavbarIcons
                    ? _c("NavbarIcon", {
                        staticClass: "navbar-icon",
                        attrs: { icon: "course" }
                      })
                    : _vm._e(),
                  _vm._v("\n      Courses\n    ")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (!_vm.isMobile(_vm.$mq) || _vm.user.is_authenticated) &&
          (_vm.user.is_classroom_teacher || _vm.user.is_classroom_student)
            ? _c(
                "router-link",
                {
                  class: {
                    "hdr-link": !_vm.isMobile(_vm.$mq),
                    "hdr-link-mobile": _vm.isMobile(_vm.$mq)
                  },
                  attrs: {
                    to: { name: "classroom" },
                    "active-class": "active",
                    "data-testid": "header_link"
                  }
                },
                [
                  _vm.showNavbarIcons
                    ? _c("NavbarIcon", {
                        staticClass: "navbar-icon",
                        attrs: { icon: "classroom" }
                      })
                    : _vm._e(),
                  _vm._v("\n      Classroom\n    ")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("search"),
          _vm._v(" "),
          _vm.user.is_authenticated
            ? _c(
                "span",
                {
                  class: {
                    "hdr-button": !_vm.isMobile(_vm.$mq),
                    "hdr-button-mobile": _vm.isMobile(_vm.$mq)
                  }
                },
                [
                  _vm.shouldOverrideHeaderButtonForReferralOrGift
                    ? _c(
                        "PremiumButton",
                        {
                          staticClass: "btn hdr-premium-btn",
                          attrs: {
                            "ax-id": _vm.premiumButtonAxId,
                            "data-testid": "app_header_premium_button"
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.premiumButtonText) +
                              "\n      "
                          )
                        ]
                      )
                    : !_vm.user.subscription_tier &&
                      !_vm.user.is_classroom_student
                    ? _c(
                        "PremiumButton",
                        {
                          staticClass: "btn hdr-premium-btn",
                          attrs: {
                            "ax-id": _vm.premiumButtonAxId,
                            "data-testid": "app_header_premium_button"
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.premiumButtonText) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm.user.can_reenable_premium_subscription
                    ? _c(
                        "router-link",
                        {
                          directives: [
                            {
                              name: "track",
                              rawName: "v-track:click",
                              value: {
                                axId: "clicked_reenable",
                                axType: "button"
                              },
                              expression:
                                "{\n          axId: 'clicked_reenable',\n          axType: 'button',\n        }",
                              arg: "click"
                            }
                          ],
                          staticClass: "btn hdr-premium-btn reenable-btn",
                          attrs: {
                            to: { name: "payment_subscription_settings" },
                            "data-testid": "app_header_premium_button"
                          }
                        },
                        [_vm._v("\n        Re-enable Premium\n      ")]
                      )
                    : !_vm.$route.path.includes("give-premium") &&
                      !_vm.user.is_classroom_student
                    ? _c(
                        "router-link",
                        {
                          directives: [
                            {
                              name: "track",
                              rawName: "v-track:click",
                              value: {
                                axId:
                                  "clicked_gift_button_header_" +
                                  (_vm.isMobile(_vm.$mq)
                                    ? "mobile"
                                    : "desktop"),
                                axType: "button"
                              },
                              expression:
                                "{\n          axId: `clicked_gift_button_header_${isMobile($mq) ? 'mobile' : 'desktop'}`,\n          axType: 'button',\n        }",
                              arg: "click"
                            }
                          ],
                          staticClass: "btn hdr-premium-btn",
                          attrs: {
                            to: { name: "gift_purchase_plans" },
                            "data-testid": "app_header_premium_button"
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.isMobile(_vm.$mq) ? "Gift" : "Gift Premium"
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "span",
                { staticClass: "hdr-login" },
                [
                  _c("SignupButton", {
                    attrs: { "ax-id": "clicked_signup_from_header" }
                  }),
                  _vm._v(" "),
                  !_vm.isMobile(_vm.$mq)
                    ? _c("LoginButton", {
                        attrs: {
                          "ax-type": "link",
                          "ax-id": "clicked_login_from_header"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
          _vm._v(" "),
          !_vm.isActuallyNux
            ? _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.$store.dispatch("streakPopup/showPopup")
                    }
                  }
                },
                [
                  _vm.user.is_authenticated
                    ? _c("StreakButton", {
                        attrs: {
                          "current-streak": _vm.currentStreak,
                          "problems-solved-in-current-streak":
                            _vm.problemsSolvedInCurrentStreak,
                          "is-mobile": _vm.mobile,
                          "notification-type": _vm.streakNotificationType,
                          "is-user-home": _vm.isUserHome,
                          "popup-visible": _vm.streakPopupVisible,
                          "calendar-days": _vm.calendar,
                          "problems-required-per-day":
                            _vm.problemsRequiredPerDay,
                          "can-increase-streak": _vm.canIncreaseStreak
                        },
                        on: {
                          "should-close": function($event) {
                            return _vm.$store.dispatch("streakPopup/hidePopup")
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.user.is_authenticated
            ? _c(
                "div",
                {
                  staticClass: "dropdown",
                  class: {
                    "hdr-settings": !_vm.isMobile(_vm.$mq),
                    "hdr-settings-mobile": _vm.isMobile(_vm.$mq)
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-toggle",
                      class: { open: _vm.showSettingsDropdown },
                      attrs: { "data-testid": "header_links_dropdown_toggle" },
                      on: { click: _vm.handleShowSettingsDropdown }
                    },
                    [
                      _c("MenuIcon", { staticClass: "icon" }),
                      _vm._v(" "),
                      _vm.notificationCount && !_vm.isMobile(_vm.$mq)
                        ? _c("span", { staticClass: "count" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.notificationCount.toLocaleString()) +
                                "\n        "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showSettingsDropdown
                    ? _c(
                        "ul",
                        {
                          staticClass: "hdr-settings-menu dropdown-menu",
                          attrs: { "data-testid": "header_links_menu" }
                        },
                        [
                          !_vm.isMobile(_vm.$mq)
                            ? _c(
                                "li",
                                {
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  }
                                },
                                [
                                  _c("NotificationsDrawer", {
                                    attrs: { loaded: _vm.notificationsLoaded }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isMobile(_vm.$mq)
                            ? _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: { name: "search" } } },
                                    [_vm._v(" Search ")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "track",
                                    rawName: "v-track:click",
                                    value: {
                                      axId: "clicked_help_hamburger_menu",
                                      axType: "link"
                                    },
                                    expression:
                                      "{\n              axId: 'clicked_help_hamburger_menu',\n              axType: 'link',\n            }",
                                    arg: "click"
                                  }
                                ],
                                attrs: {
                                  href: _vm.$router.resolve({
                                    name: "flatpage_faq"
                                  }).href
                                }
                              },
                              [_vm._v("\n            Help\n          ")]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "avatar_change" } } },
                                [_vm._v(" Account ")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: _vm.user.profile_url } },
                                [_vm._v(" Profile ")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.canRefer
                            ? _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      directives: [
                                        {
                                          name: "track",
                                          rawName: "v-track:click",
                                          value: {
                                            axId:
                                              "clicked_refer_friend_hamburger_menu"
                                          },
                                          expression:
                                            "{ axId: 'clicked_refer_friend_hamburger_menu' }",
                                          arg: "click"
                                        }
                                      ],
                                      staticClass: "refer",
                                      attrs: { to: { name: "referrer_home" } }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Refer a friend\n          "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.user.is_external_lesson_author ||
                          _vm.user.is_staff
                            ? _c(
                                "li",
                                [
                                  _vm.featureSwitches.use_retool_campgrounds
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.retoolAuthorsDashboard
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n            Brilliant for Authors\n          "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "authors_dashboard" }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n            Brilliant for Authors\n          "
                                          )
                                        ]
                                      )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "account_logout" } } },
                                [_vm._v(" Log out ")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.isMobile(_vm.$mq)
                            ? _c("li", { staticClass: "divider" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.user.show_legacy_profile
                            ? [
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "router-link",
                                      { attrs: { to: { name: "algebra" } } },
                                      [_vm._v(" Practice ")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "profile_forlater_component"
                                          }
                                        }
                                      },
                                      [_vm._v(" Saved ")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "problems_started_problems"
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              Recent problems\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.isMobile(_vm.$mq)
                                  ? _c("li", { staticClass: "divider" })
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isMobile(_vm.$mq)
                            ? _c(
                                "li",
                                { staticClass: "tertiary" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { name: "learning_manifesto" }
                                      }
                                    },
                                    [_vm._v(" Our Principles ")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isMobile(_vm.$mq) &&
                          (_vm.user.student_country_name === "USA" ||
                            _vm.user.student_country_name === "Canada")
                            ? _c(
                                "li",
                                { staticClass: "tertiary" },
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: { name: "careers_page" } } },
                                    [_vm._v(" Want to work at Brilliant? ")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isMobile(_vm.$mq)
                            ? _c(
                                "li",
                                { staticClass: "tertiary" },
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: { name: "testimonials" } } },
                                    [_vm._v(" Testimonials ")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.moderatorOrStaff
                            ? _c("li", { staticClass: "divider" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.moderatorOrStaff && !_vm.isMobile(_vm.$mq)
                            ? _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { name: "moderators_dashboard" }
                                      }
                                    },
                                    [_vm._v(" Moderator dashboard ")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.user.is_staff && !_vm.isMobile(_vm.$mq)
                            ? _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { name: "staff_create_test_user" }
                                      }
                                    },
                                    [_vm._v(" Create test user ")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.user.is_staff
                            ? _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: { name: "nux_welcome" } } },
                                    [_vm._v(" Re-do the NUX ")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }